import React from "react";
import { Modal } from "react-bootstrap";
import { StockPhotos } from "./StockPhotos";

interface Props {
  onClose: () => void,
  onSelect: (img: string) => void
}

export const StockModal: React.FC<Props> = (props: Props) => {

  const handleStockSelect = (url: string) => {
    props.onSelect(url);
  }

  return (<>
    <Modal id="previewModal" show={true} dialogClassName="custom-modal" bsClass="my-modal" onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Stock Photos</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex" }}>
        <StockPhotos onSelect={props.onSelect} onStockSelect={handleStockSelect} />
      </Modal.Body>
    </Modal>
  </>);
};
